// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.voice-rerecord-card {
  margin-top: 0;
  padding: 0;
  border: 0;
  border-radius: 12px;
  background: #fff;
}

.voice-rerecord-header h2 {
  margin: 0 0 6px 0;
  font-size: 18px;
}

.voice-rerecord-header p {
  margin: 0 0 10px 0;
  color: #555;
}

.voice-rerecord-meta .pill {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(34, 197, 94, 0.12);
  color: #166534;
  font-weight: 600;
  font-size: 12px;
}

.voice-rerecord-actions {
  margin-top: 12px;
}

.recording-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.recording-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ef4444;
  box-shadow: 0 0 0 6px rgba(239, 68, 68, 0.15);
}

.recording-time {
  font-variant-numeric: tabular-nums;
  color: #111;
  font-weight: 600;
}

.voice-rerecord-preview audio {
  width: 100%;
  margin-top: 10px;
}

.voice-rerecord-buttons {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.primary, .secondary, .danger {
  border: 0;
  padding: 10px 14px;
  border-radius: 10px;
  cursor: pointer;
  font-weight: 600;
}

.primary {
  background: #2563eb;
  color: white;
}

.secondary {
  background: rgba(37, 99, 235, 0.12);
  color: #1d4ed8;
}

.danger {
  background: rgba(239, 68, 68, 0.12);
  color: #b91c1c;
}

.primary:disabled, .secondary:disabled, .danger:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.hint {
  margin-top: 8px;
  font-size: 12px;
  color: #666;
}

.success {
  margin-top: 10px;
  color: #166534;
  font-weight: 600;
}

.error {
  margin-top: 10px;
  color: #b91c1c;
  font-weight: 600;
}

/* Popup modal for delete confirmation (VoiceCloning) – rendered in portal above page */
.voice-clone-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
}

.voice-clone-modal {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  max-width: 400px;
  width: 100%;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.voice-clone-modal p {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 15px;
}

/* Indeterminate progress bar for "Creating your AI voice..." */
.voice-clone-progress-wrap {
  width: 100%;
  height: 8px;
  border-radius: 999px;
  background: rgba(37, 99, 235, 0.15);
  overflow: hidden;
  margin: 12px 0 10px 0;
}

.voice-clone-progress-bar {
  height: 100%;
  width: 40%;
  min-width: 80px;
  border-radius: 999px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    #2563eb 30%,
    #3b82f6 50%,
    #2563eb 70%,
    transparent 100%
  );
  background-size: 200% 100%;
  animation: voice-clone-progress-slide 1.8s ease-in-out infinite;
}

@keyframes voice-clone-progress-slide {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(350%);
  }
}

.voice-clone-checking-hint {
  font-size: 12px;
  color: #6b7280;
  margin-top: 6px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.voice-clone-checking-hint::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #22c55e;
  animation: voice-clone-pulse 1.5s ease-in-out infinite;
}

@keyframes voice-clone-pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.6;
    transform: scale(0.9);
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/VoiceReRecord.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,mCAAmC;EACnC,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,uFAAuF;AACvF;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA,+DAA+D;AAC/D;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,mCAAmC;EACnC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,eAAe;EACf,oBAAoB;EACpB;;;;;;;GAOC;EACD,0BAA0B;EAC1B,+DAA+D;AACjE;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF","sourcesContent":[".voice-rerecord-card {\n  margin-top: 0;\n  padding: 0;\n  border: 0;\n  border-radius: 12px;\n  background: #fff;\n}\n\n.voice-rerecord-header h2 {\n  margin: 0 0 6px 0;\n  font-size: 18px;\n}\n\n.voice-rerecord-header p {\n  margin: 0 0 10px 0;\n  color: #555;\n}\n\n.voice-rerecord-meta .pill {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: rgba(34, 197, 94, 0.12);\n  color: #166534;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.voice-rerecord-actions {\n  margin-top: 12px;\n}\n\n.recording-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.recording-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #ef4444;\n  box-shadow: 0 0 0 6px rgba(239, 68, 68, 0.15);\n}\n\n.recording-time {\n  font-variant-numeric: tabular-nums;\n  color: #111;\n  font-weight: 600;\n}\n\n.voice-rerecord-preview audio {\n  width: 100%;\n  margin-top: 10px;\n}\n\n.voice-rerecord-buttons {\n  display: flex;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.primary, .secondary, .danger {\n  border: 0;\n  padding: 10px 14px;\n  border-radius: 10px;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.primary {\n  background: #2563eb;\n  color: white;\n}\n\n.secondary {\n  background: rgba(37, 99, 235, 0.12);\n  color: #1d4ed8;\n}\n\n.danger {\n  background: rgba(239, 68, 68, 0.12);\n  color: #b91c1c;\n}\n\n.primary:disabled, .secondary:disabled, .danger:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.hint {\n  margin-top: 8px;\n  font-size: 12px;\n  color: #666;\n}\n\n.success {\n  margin-top: 10px;\n  color: #166534;\n  font-weight: 600;\n}\n\n.error {\n  margin-top: 10px;\n  color: #b91c1c;\n  font-weight: 600;\n}\n\n/* Popup modal for delete confirmation (VoiceCloning) – rendered in portal above page */\n.voice-clone-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  padding: 20px;\n}\n\n.voice-clone-modal {\n  background: #fff;\n  border-radius: 12px;\n  padding: 24px;\n  max-width: 400px;\n  width: 100%;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n}\n\n.voice-clone-modal p {\n  margin: 0 0 20px 0;\n  color: #333;\n  font-size: 15px;\n}\n\n/* Indeterminate progress bar for \"Creating your AI voice...\" */\n.voice-clone-progress-wrap {\n  width: 100%;\n  height: 8px;\n  border-radius: 999px;\n  background: rgba(37, 99, 235, 0.15);\n  overflow: hidden;\n  margin: 12px 0 10px 0;\n}\n\n.voice-clone-progress-bar {\n  height: 100%;\n  width: 40%;\n  min-width: 80px;\n  border-radius: 999px;\n  background: linear-gradient(\n    90deg,\n    transparent 0%,\n    #2563eb 30%,\n    #3b82f6 50%,\n    #2563eb 70%,\n    transparent 100%\n  );\n  background-size: 200% 100%;\n  animation: voice-clone-progress-slide 1.8s ease-in-out infinite;\n}\n\n@keyframes voice-clone-progress-slide {\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(350%);\n  }\n}\n\n.voice-clone-checking-hint {\n  font-size: 12px;\n  color: #6b7280;\n  margin-top: 6px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.voice-clone-checking-hint::before {\n  content: \"\";\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #22c55e;\n  animation: voice-clone-pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes voice-clone-pulse {\n  0%, 100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.6;\n    transform: scale(0.9);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
